var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "import-reports-index-view"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('titles.index')))]), _vm._v(" "), _c('h3', [_vm._v("Neuen Import starten")]), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.$t('actions.enqueueBrodosFullImport')
    },
    on: {
      "confirm": function($event) {
        _vm.enqueueBrodosFullImport()
      }
    }
  }), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.$t('actions.enqueueBrodosFullImportWithoutAttachments')
    },
    on: {
      "confirm": function($event) {
        _vm.enqueueBrodosFullImportWithoutAttachments()
      }
    }
  }), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.$t('actions.enqueueBrodosDynamicDataImport')
    },
    on: {
      "confirm": function($event) {
        _vm.enqueueBrodosDynamicDataImport()
      }
    }
  }), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.$t('actions.enqueueBrodosBundleImport')
    },
    on: {
      "confirm": function($event) {
        _vm.enqueueBrodosBundleImport()
      }
    }
  }), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.$t('actions.enqueuePxsdbFullImport')
    },
    on: {
      "confirm": function($event) {
        _vm.enqueuePxsdbFullImport()
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Bisherige Importe")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importer),
      expression: "importer"
    }],
    attrs: {
      "name": "importer"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.importer = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeImporterFilter]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brodos,brodos_articles,pxsdb_articles"
    }
  }, [_vm._v("Artikel - Alle ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pxsdb_articles"
    }
  }, [_vm._v("Artikel - Pxsdb")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brodos,brodos_articles"
    }
  }, [_vm._v("Artikel - Brodos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brodos_bundles"
    }
  }, [_vm._v("Bundles")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brodos,brodos_categories"
    }
  }, [_vm._v("Kategorien")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brodos,brodos_dynamic_data,telekom_product_availabilities"
    }
  }, [_vm._v("Verfügbarkeiten")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brodos"
    }
  }, [_vm._v("Alte Vollimporte")])]), _vm._v(" "), (_vm.gridLoaded) ? _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "editable": false,
      "is-loading": _vm.isLoading,
      "page-info": _vm.importReports.pagination,
      "removable": false,
      "sortable": ['importer', 'scope', 'status', 'insertedAt'],
      "sort-info": _vm.importReports.sort,
      "rows": _vm.importReports.entries
    },
    on: {
      "sort": _vm.sortBy
    },
    scopedSlots: _vm._u([{
      key: "importer",
      fn: function(importerProps) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'import-report',
              params: {
                id: importerProps.row.id
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.$t(("importers." + (importerProps.value)))))])]
      }
    }, {
      key: "status",
      fn: function(statusProps) {
        return [_c('import-status', {
          attrs: {
            "errors": statusProps.row.errorsCount,
            "value": statusProps.value
          }
        })]
      }
    }, {
      key: "scope",
      fn: function(scopeProps) {
        return [(scopeProps.value) ? _c('span', [_vm._v("\n       " + _vm._s(scopeProps.value) + "\n       "), _c('br'), _vm._v("\n       " + _vm._s(scopeProps.row.fileName) + "\n      ")]) : _c('text-placeholder')]
      }
    }, {
      key: "insertedAt",
      fn: function(wallclock) {
        return [(wallclock.row.startedAt) ? _c('span', [_vm._v("\n         ↦ " + _vm._s(_vm._f("niceTime")(wallclock.row.startedAt)) + "\n       ")]) : _vm._e(), _vm._v(" "), (wallclock.row.finishedAt) ? _c('span', [_c('br'), _vm._v("\n          ⇥ " + _vm._s(_vm._f("niceTime")(wallclock.row.finishedAt)) + "\n       ")]) : _vm._e()]
      }
    }])
  }) : _c('div', {
    staticClass: "loader-container uk-container uk-margin-medium-top uk-text-center"
  }, [_c('loader')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4368fcc3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ImportReports/IndexView.vue
// module id = 1961
// module chunks = 0